
export enum ProcessType {
	ProductFeed = 'ProductFeed',
	ProductFeedPreprocessing = 'ProductFeedPreprocessing',
	ProductRanking = 'ProductRanking',
	ProductRecommendations = 'ProductRecommendations',
	ProductCatalog = 'ProductCatalog',
	Compositions = 'Compositions',
	PersonalisedCompositions = 'PersonalisedCompositions'
}

export enum ProcessState {
	None = 'None',
	Pending = 'Pending',
	OnGoing = 'OnGoing',
	TerminatedWithSuccess = 'TerminatedWithSuccess',
	TerminatedWithError = 'TerminatedWithError',
	TerminatedWithNoOp = 'TerminatedWithNoOp'
}

export enum ProcessRequestStatus {
	Pending = 'Pending',
	Archived = 'Archived'
}

export interface ProcessQueue {
	processIdentifier: string;
	processType: ProcessType;
}

export interface ProcessModel {
	processIdentifier?: string;
	lastSuccessDateUtc?: string | null; // Format: ISO 8601 date-time string
	message?: string;
	processState: ProcessState;
	stateDateUtc?: string | null; // Format: ISO 8601 date-time string
	requests?: ProcessRequestModel[];
}
export type ProcessWorkflowState = {
	processType: ProcessType;
	mainState: ProcessModel;
	stateWithIdentifiers: ProcessModel[]
}

export interface CreateProcessRequest {
	processType: ProcessType;
	processIdentifier: string;
	force?: boolean | null;
}
export interface ProcessRequestModel {
	requestStatus: ProcessRequestStatus;
	requestDateUtc: string; // Format: ISO 8601 date-time string
	originatorServiceName: string | null;
	originatorUserEmail: string | null;
}

export interface RequestState {
	requestStatus: string;
	requestDateUtc: string;
	originatorServiceName: string | null;
	originatorUserEmail: string | null;
}

export type ProcessWorkflowPermission = {
	processType: ProcessType;
	canRequest: boolean;
}

export type ProcessWorkflowConfiguration = {
	availableProcesses: ProcessType[],
	permissions: ProcessWorkflowPermission[]
}